import { apiClient } from '../client/apiClient';
import type {
	IOtpVerification,
	IPasswordChange,
	IPasswordForgot,
	IPasswordReset,
	IResendOtp,
} from '../types/auth';
import type { IBaseResponse } from '../types/common';

export const passwordService = {
	/**
	 * Change password
	 */
	changePassword: (data: IPasswordChange) =>
		apiClient.put<IBaseResponse<void>>('/password/change', data),

	/**
	 * Reset password
	 */
	resetPassword: (data: IPasswordReset) =>
		apiClient.put<IBaseResponse<void>>('/password/reset', data),

	/**
	 * Forgot password
	 */
	forgotPassword: (data: IPasswordForgot) =>
		apiClient.put<IBaseResponse<string>>('/password/forgot', data),

	/**
	 * Verify OTP for password reset
	 */
	verifyOtp: (data: IOtpVerification) =>
		apiClient.put<IBaseResponse<string>>('/password/forgot/verify-otp', data),

	/**
	 * Resend OTP for password reset
	 */
	resendOtp: (data: IResendOtp) =>
		apiClient.put<IBaseResponse<string>>('/password/forgot/resend-otp', data),
};
